const appConfig = {
  clientId: process.env.VUE_APP_CLIENT_ID
}
export default appConfig
